import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private instance: HTMLIonToastElement;

  constructor(private readonly toast: ToastController) {}

  // position anchor introduced in ionic version 7.5
  async present(message: string, duration: number = 5000, position: 'top' | 'bottom' | 'middle' = 'bottom'/*, positionAnchor?: string*/): Promise<void> {
    // const anchor= positionAnchor ?? position === 'top' ? 'app-header' : (position === 'bottom' ? 'app-footer' : undefined);
    this.instance = await this.toast.create({
      message,
      duration,
      position,
      // positionAnchor,
    });
    await this.instance.present();
  }

  dismiss(): void {
    if (!!this.instance) {
      this.instance.dismiss().then();
    }
  }
}
